import lo from 'lodash'

export const Months = [
  {
    value: '',
    label: 'All'
  },
  {
    value: 1,
    label: 'January'
  },
  {
    value: 2,
    label: 'February'
  },
  {
    value: 3,
    label: 'March'
  },
  {
    value: 4,
    label: 'April'
  },
  {
    value: 5,
    label: 'May'
  },
  {
    value: 6,
    label: 'June'
  },
  {
    value: 7,
    label: 'July'
  },
  {
    value: 8,
    label: 'August'
  },
  {
    value: 9,
    label: 'September'
  },
  {
    value: 10,
    label: 'October'
  },
  {
    value: 11,
    label: 'November'
  },
  {
    value: 12,
    label: 'December'
  }
]

export const Status = [
  {
    value: '',
    label: 'All'
  },
  {
    value: 'OPEN',
    label: 'Open'
  },
  {
    value: 'CLOSED',
    label: 'Closed'
  }
]

export const Years = (lo.range(2019, new Date().getFullYear() + 2, 1));